import i18n from "../lang/i18n";

const validations = {
  name: {
    required: true,
    maxLength: 255
  },
  subjectCode: {
    maxLength: 4
  },
  credit: {
    format: {
      valid: value => /^\d{1,255}(\.\d{1,255})?$/.test(value.trim()),
      message: i18n.t("validation.the_credit_must_be_a_positive_number")
    }
  },
  subject: {
    required: true,
    maxLength: 255
  },
  weight: {
    format: {
      valid: value => /^\d{1,255}(\.\d{1,255})?$/.test(value),
      message: i18n.t("validation.the_weight_must_be_number")
    }
  }
};
export { validations };
